import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../shared/services/commen/commen.services';
import { OrdersService } from '../shared/services/orders/orders.service';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { DatePipe } from '@angular/common';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { ITableModel } from '../shared/components/table/model/tableModel';
import { Observable } from 'rxjs';
import { NewUlipComponent } from '../shared/components/new-ulip/new-ulip.component';
import { UlipService } from '../shared/services/Ulip/ulip.service';
import { Helpers } from '../helpers';
declare var google: any;
@Component({
  selector: 'app-new-shipment-request-page',
  templateUrl: './new-shipment-request-page.component.html',
  styleUrls: ['./new-shipment-request-page.component.scss']
})
export class NewShipmentRequestPageComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  TenantId: any;
  CompanyId: any;
  userId: any;
  data: any = {};
  OrderNo: any = '';
  // @Input() data: any;
  @Input() IsSaveDisable: any = false;
  @Output() onSave = new EventEmitter<any>();
  TransportServiceList: any;
  static that: NewShipmentRequestPageComponent;
  PackageDetails: ITableModel;
  BidDetailData: any = {};
  OrderListDetails: any = [];
  VehicleDetails: any = [];
  PackageListDetails: any = [];
  AssignVehicleList: any = [];
  IndentId: string = '';
  TransporterId: any = '';
  BidDetailId: any
  ServType: any = '';
  VehicleTypeId: any = '';
  whitelabelFlag: boolean = false;
  courierListIds: any = [];
  CourierList: any = [];
  ManualvehicleOrderList: any = [];
  ManualvehicleOrderDetail = [];
  ManualvehiclePlanning: any = {};
  isSTPBooking: any = false;
  ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag = false;
  CourierPackages: any = [];
  CourierDimentions: any = [];
  CourierAdditionalPack: any = [];
  TransportNames: any = [];
  OrderData: any = {};
  OrdersPackage: any = [];
  CourierRate: any = [];
  NetTotal: any = 0;
  IsAssignvehicleSaveDisable: any = false;
  TransporterType: any;
  isHiredTransporter: boolean = false;
  isBookingCreated: boolean = false;
  @ViewChild('ulipComp') ulipComp: NewUlipComponent;
  IsVarifiedUlip: boolean = false;

  TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'TransportService',
    dataField: 'TransportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Transporter: any = {
    lable: 'Transporter',
    formControlName: 'Transporter',
    dataField: 'Transporter',
    isRequired: true,
    placeholder: 'Select Transporter',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'VehicleType',
    dataField: 'VehicleType',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'VehicleNo',
    dataField: 'VehicleNo',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    addTag: false,
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: true,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    addTag: false,
  };
  DriverMobileNo = {
    lable: 'Driver Mobile No',
    formControlName: 'DriverMobileNo',
    dataField: 'DriverMobileNo',
    isRequired: true,
    placeholder: 'Enter Driver Mobile No',
  };
  VehiclePlacementDate = {
    lable: 'Vehicle Placement Date',
    formControlName: 'VehiclePlacementDate',
    dataField: 'VehiclePlacementDate',
    isRequired: true,
    placeholder: 'Select Vehicle Placement Date',
    isTime: true, 
  };
  LeadTime = {
    lable: 'Lead Time in Days',
    formControlName: 'LeadTime',
    dataField: 'LeadTime',
    isRequired: false,
    placeholder: 'Enter Lead Time in Days',
    type: 'number'
  };
  EstimatedDeliveryDate = {
    lable: 'Estimated Delivery Date',
    formControlName: 'EstimatedDeliveryDate',
    dataField: 'EstimatedDeliveryDate',
    isRequired: true,
    placeholder: 'Select Estimated Delivery Date',
    isTime: true, 
  };
  Advance = {
    lable: 'Advance',
    formControlName: 'Advance',
    dataField: 'Advance',
    isRequired: false,
    placeholder: 'Enter Advance',
    type: 'number'
  };

  Orderdetail: any = {
    cardName: "Indent No",
    NewHeaderData: true,
    id: "orderInfo",
    isShowOrderNo: true,
    // IndentNo:"OrderNo",
    // NewlistOfRow: [
    //   [
    //     {
    //       label: "",
    //       dataField1: "OrderNo",
    //     },
    //   ]
    // ],
    listOfRow: [
      [
        {
          label: "Pickup",
          dataField: "PickUpContactPerson",
          dataField1: "PickupAddress",
        },
        {
          label: "Delivery",
          dataField: "DeliveryContactPerson",
          dataField1: "DeliveryAddress",
        },
      ],
      [
        { label: "Pickup Date", dataField: "PickupDate" },
        { label: "Delivery Date", dataField: "DeliviryDate" },
      ],
    ],
    isColumnNameShow: true,
  };

  TransporterDetails: any = {
    cardName: "Transporter Details",
    id: "orderInfo",
    listOfRow: [
      [
        {
          dataField: "Transporter",
          // dataField1: "TransportModeType",
          imgDataField: "LogoPath",
          valueType: "isNewTransporter",
          isNewRating: true,
          dataFieldRating: "StarRating",
        },
      ],
      [{ isNewHrLine: true }],
      [
        {
          phonedataField: "TransporterPhone",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/phone.svg",
          isNewPhone: true,
          color: "#3b67fb",
        },
      ],
      [
        {
          EmaildataField: "TransporterEmail",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/newemail.svg",
          isNewEmail: true,
          color: "#3b67fb",
        },
      ],
    ],
    isColumnNameShow: true,
  };

  isMobileView: any;

  //Start - added by fahim 30-12-2025 :)
  DriverLicenseNo = {
    lable: 'Driver License No',
    formControlName: 'DriverLicenseNo',
    dataField: 'DriverLicenseNo',
    isRequired: false,
    placeholder: 'Enter Driver License No',
  };
  DriverDOB = {
    lable: 'Driver DOB',
    formControlName: 'DriverDOB',
    dataField: 'DriverDOB',
    isRequired: false,
    placeholder: 'Select Driver DOB',
  };

  TransportersType: any;
  vahanData: any;
  isVehValid: boolean = false;
  vahanDataList: any = [];
  sarathiDataList: any = [];
  sarathiData: any;
  isDriverValid: boolean = false;
  //End - added by fahim 30-12-2025 :)

  constructor(
    private route: ActivatedRoute,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private anghttp: Http,
    private commonService: CommonService,
    private decryptpipe: DecryptPipe,
    private service: TranslateConfigService,
    private modalService: NgbModal,
    private orderService: OrdersService,
    private router: Router,
    private dp: DatePipe,
    private _activatedRoute: ActivatedRoute,
    private _script: ScriptLoaderService,
    private Ulip: UlipService // Added by priya - 14/03/2026 - Importing ulip service for using common function - cn(PRIYA-MAR26-002)
  ) { 
    NewShipmentRequestPageComponent.that = this;
  }

  ngOnInit() {
    this._script.loadScripts("body",
      [
        "assets/vendors/base/vendors.bundle.js",
        "assets/demo/default/base/scripts.bundle.js"
      ],
      true
    ).then(() => {
      this._activatedRoute.params.subscribe((params: Params) => {
        this.IndentId = this._activatedRoute.snapshot.queryParams["IndentId"];
        this.TransporterId = this._activatedRoute.snapshot.queryParams["Transporter"];
        this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));
        this.ServType = this._activatedRoute.snapshot.queryParams["Type"];
        this.VehicleTypeId = this._activatedRoute.snapshot.queryParams["VehicleTypeId"];
        this.BidDetailId = this._activatedRoute.snapshot.queryParams["TransporterBidDetailId"];
        if (this.IndentId == undefined || this.IndentId == null) {
          this.IndentId = this._activatedRoute.snapshot.queryParams["indentid"];
          this.TransporterId = this._activatedRoute.snapshot.queryParams["transporter"];
          this.ServType = this._activatedRoute.snapshot.queryParams["type"];
          this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelflag"));
          this.VehicleTypeId = this._activatedRoute.snapshot.queryParams["vehicletypeid"];

        }

        this.BiddingList();
        this.GetBidDetails();
        // this.data.Transporter=this.TransporterId;
        // this.GetTransporterList(this.data.TransporterName, false);
        this.GetTransportService();
        if (this.IndentId) {
          if (this.ServType == 'FTL') {
            this.initiateCourierList(this.IndentId);
          }
        }

        setTimeout(() => {
          console.log("this.ServType (inside subscribe):", this.ServType);
        }, 2000);
        console.log("this.IndentId (inside subscribe):", this.IndentId);
        console.log("this.TransporterId (inside subscribe):", this.TransporterId);

        this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
        this.getDropdownList('%%', this.VehicleType);
        this.data.Transporter = this.TransporterId;
        this.GetTransporterList('%%', false);
        this.data.VehicleType=this.VehicleTypeId;
        this.getTransporterType();
      });
    });

    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.LoadULIPVerification();  //added by fahim 30-12-2025 :)
    // this.data = this.data;
    // if(this.data.VehicleNo){
    //   this.GetVehicleNoList(this.data.VehicleNo, false);
    // }
    if(this.data.Driver !== '' || this.data.Driver !== null){
      const DriverName = decodeURIComponent(this.data.DriverName); // Decode Driver
      const DriverCode = decodeURIComponent(this.data.DriverCode);
      if (this.data.DriverCode) {
        this.GetDriverList(this.data.DriverCode, false)
      } else {
        this.GetDriverList(this.data.DriverName, false)
      }
    } else {
      console.log('calling')
      this.Driver.placeholder = 'Select Driver'
    }
    console.log('details', this.data, this.data)
    // this.data.Transporter = this.data.Transporter.toLowerCase();
    // this.GetTransporterList(this.data.TransporterName, false);

    console.log("this.IndentId:", this.IndentId);
    console.log("this.IndentId:", this.TransporterId);

    // this.GetBidDetails();
    this.GetTransportService();
    this.getDropdownList(null, this.TransportService);
    console.log("this.data.TransportService:", this.data.TransportService);

    this.data.VehiclePlacementDate = this.dp.transform(new Date(),"dd-MMM-yyyy HH:mm");
    this.data.EstimatedDeliveryDate = this.dp.transform(new Date(),"dd-MMM-yyyy HH:mm");
  }

  async BiddingList() {
    this.PackageDetails = {
      data: [],
      columnDetails: [
        { columnName: "Product Name", dataFieldName: "ProductName" },
        { columnName: "Qty", dataFieldName: "Qty" },
        { columnName: "Weight", dataFieldName: "weight" },
        { columnName: "CBM", dataFieldName: "CBM" },
        { columnName: "Amount", dataFieldName: "InvoiceAmount" },
      ],
      footerData: [
        { ProductName: "Total", Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true,
    };
  }

  close() {
    this.onCloseEvent.emit();
  }

  GetTransportService() {
    this.orderService.GetTransportServiceList().then((res) => {
      this.TransportServiceList = res;
      this.data.TransportService = this.TransportServiceList.filter(
        (x) => x.Label === this.ServType)[0].Id;
    })
      .catch((error) => {
        console.log(error);
      });
  }

  getTransporterType(){
    this.orderService.TransporterSelect2("%%", 1, this.TenantId).then((res) => {
      console.log('res', res)
      this.TransporterType = res.filter((x) => x.id === this.TransporterId )[0].TransporterType;
      if(this.TransporterType == 'Hired'){
        // this.VehicleNo.addTag = true
        this.isHiredTransporter = true
      } else {
        // this.VehicleNo.addTag = false
        this.isHiredTransporter = false
      }
      console.log(this.VehicleNo)
    })
    .catch((error) => {
      console.log(error);
    });
  }

  getChangedValue(value, data) {
    if (data.dataField == 'Transporter') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'VehicleNo') {
       const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
      console.log('vehicle value', value)
      if(this.isHiredTransporter){
        this.data[data.dataField] = newValue;
      } else {
        this.data[data.dataField] = newValue;
      }
    } else if (data.dataField == 'Driver') {
      if(value.isFromAPI === true){
        this.data[data.dataField] = value.value;
        this.data.DriverMobileNo = value.MobileNo;
        // Added by priya - 31/03/2026 - cn(PRIYA-MAR26-015)
        this.data.DriverLicenseNo = value.LicenseNo || null;
        this.data.DriverDOB = value.DOB || null;
        // End by priya
      }else{
        this.data[data.dataField] = value;
      }
    } else if (data.dataField == 'LeadTime') {
      this.data[data.dataField] = value;

      const result = new Date(this.data.VehiclePlacementDate);
      result.setDate(result.getDate() + parseInt(value));
      this.data.EstimatedDeliveryDate = this.dp.transform(result, 'dd-MMM-yyyy HH:mm');
    } else {
      this.data[data.dataField] = value;
    }
  }

  getDropdownList(value, data) {
    if (data.dataField === 'TransportService') {
      this.searchStatusOnField(data, true);
      this.orderService.GetTransportServiceList().then(res => {
        this.findObjectOfTheFieldV2(this.TransportService, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
    if (data.dataField === 'VehicleType') {
      this.searchStatusOnField(data, true);
      this.orderService.GetVehicleTypeselect2(value, 1).then(res => {
        this.findObjectOfTheFieldV2(this.VehicleType, res);
      }).catch(error => {
        this.searchStatusOnField(data, false);
      })
    }
  }

  findObjectOfTheFieldV2(data, dropdownList) {
    data.dropdownList = dropdownList;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  GetTransporterList(value, isScrollDown = false) {
    this.Transporter.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Transporter.dropdownList.length / 20) + 1;
    }
    this.orderService.TransporterSelect2(value, pageNo, this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Transporter.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Transporter.dropdownList);
        this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Transporter = { ...this.Transporter, dropdownList: [...dropdownList] });
      this.Transporter.isSearch = false;
      this.callTransportersType();
    }).catch(error => {
      this.Transporter.isSearch = false;
    })
  }

  GetVehicleNoList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 40) + 1;
    }
    this.orderService.GetAssignVehicleVehicleDriverList(value, pageNo, this.CompanyId,this.data.Transporter, this.data.VehicleType).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 40) + 1;
    }
    this.orderService.GetDriverSelect2(value, pageNo, this.data.Transporter).then(res => {
      // let dropdownList = [...res];
      let dropdownList = res.map(item => ({
        ...item,
        isFromAPI: true
      }));
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if (!this.data.TransportService) {
      IsAllDataDone = false;
    }
    if (!this.data.Transporter) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleType) {
      IsAllDataDone = false;
    }
    if (!this.data.VehicleNo) {
      IsAllDataDone = false;
    }
    if (!this.data.Driver) {
      IsAllDataDone = false;
    }
    if (!this.data.DriverMobileNo) {
      IsAllDataDone = false;
    }
    if (!this.data.EstimatedDeliveryDate) {
      IsAllDataDone = false;
    }
    if (!this.data.VehiclePlacementDate) {
      IsAllDataDone = false;
    }
    if(this.ULIPVerification){
      if (!this.data.DriverLicenseNo) {
            IsAllDataDone = false;
      }
      if (!this.data.DriverDOB) {
            IsAllDataDone = false;
      }
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  onAssignVehicleClick(){
    // const isUlipVerified = (this.ULIPVerification === true);
    // if(isUlipVerified){
    //   this.isFormSubmit = true;
    //   if (this.ValidateData()){
    //     this.ValidateBothVehDriver();
    //   }
    // }else{
      this.OnSaveAssignVehicle();
    // }
  }

  // changed by priya - 28/01/25
  // vehicle assign process and after assign vehicle updates bid detail 
  hasSubmitted = false;
  OnSaveAssignVehicle() {
    if (this.IsAssignvehicleSaveDisable || this.hasSubmitted) {
    console.log('OnSaveAssignVehicle already clicked');
    return;
    }
    // added by priya - 02/09/2025
    // if required vehicles count are fulfilled for order and pending vehicle is 0 then it will show warning
    let pendingCount = 0;
    Helpers.setLoading(true);
    this._appService.GetById("OrdersByVehicle", "GetNewOrdersDetailList", this.IndentId).subscribe((res) => {
      pendingCount = res.Table[0].Pending;
      if (pendingCount <= 0){
        this.toastr.warning('Transporter is allocated for this shipment', 'Warning')
        Helpers.setLoading(false);
        return
      } else {
        this.isFormSubmit = true;
        if (this.ValidateData()) {
          // Added by priya - 30/03/2026 - cn(PRIYA-MAR26-015)
          if (this.ULIPVerification === true) {
            if (this.ulipComp) {
              const weightMismatch = this.ulipComp.IsVahanWeightMismatchValidity && this.ulipComp.isWeightMismatch;
              if (this.ulipComp.hasAnyExpired() || weightMismatch) {
                this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
                return;
              }
            }
            // if (this.ulipComp && (this.ulipComp.hasAnyExpired() || this.ulipComp.isWeightMismatch)) {
            //   this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
            //   Helpers.setLoading(false);
            //   return;
            // }
          }
          this.IsAssignvehicleSaveDisable = true;
          this.ManualvehicleOrderList = this.CourierList;
          var FinalDestination = this.ManualvehicleOrderList[0].DeliveryLocationCode;
          var StartDestination = this.ManualvehicleOrderList[0].PickupLocationCode || null;
          console.log('data', this.data)
          this._appService.GetByTwoId("Booking", "GetOrderAddressFromLocationCode", StartDestination, FinalDestination).subscribe(async (response) => {
            var DestinationLocation = "";
            DestinationLocation = response[0].DeliveryAddress;
            var DeliveryAddressUnique: any = [];
            var OrderInfo: any = [];
            var obj1: any = {};
            (obj1.origin = this.ManualvehicleOrderList[0].PickupAddress), (obj1.destination = response[0].DeliveryAddress);
            OrderInfo.push(obj1);
    
            this.ManualvehicleOrderList.map(function (item) {
              if (NewShipmentRequestPageComponent.that.ManualPlanningDestinationValuesFromPinCodeDeliveryBranchFlag == true) {
                item.DeliveryAddress = response[0].DeliveryAddress;
              }
              var existItem = DeliveryAddressUnique.find((x) => x.location == item.DeliveryAddress);
              if (!existItem) {
                var obj: any = {};
                (obj.location = item.DeliveryAddress),
                  (obj.stopover = true),
                  (obj.Order = 0),
                  (obj.RouteOrder = "A");
                DeliveryAddressUnique.push(obj);
              }
            });
    
            var DeliveryAddressUniqueResult: any = [];
            NewShipmentRequestPageComponent.that.calculateRouteOptimization(OrderInfo, DeliveryAddressUnique).then(async (res) => {
              setTimeout(() => {
                DeliveryAddressUniqueResult = res;
                for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
                  for (let j = 0; j < DeliveryAddressUniqueResult.length; j++) {
                    if (
                      this.ManualvehicleOrderList[i].DeliveryAddress ==
                      DeliveryAddressUniqueResult[j].location
                    ) {
                      this.ManualvehicleOrderList[i].RouteOrder =
                        DeliveryAddressUniqueResult[j].RouteOrder;
                    }
                  }
                }
    
                for (let i = 0; i < this.ManualvehicleOrderList.length; i++) {
                  this.ManualvehicleOrderDetail[i] = {};
                  this.ManualvehicleOrderDetail[i].OrderID = this.ManualvehicleOrderList[i].Id;
                  this.ManualvehicleOrderDetail[i].PickupLocationCode = this.ManualvehicleOrderList[i].PickupLocationCode;
                  this.ManualvehicleOrderDetail[i].DeliveryLocationCode = FinalDestination;
                  if (this.isSTPBooking) {
                    this.ManualvehicleOrderDetail[i].DeliveryLocationCode = this.ManualvehicleOrderList[i].DeliveryLocationCode;
                  }
                  this.ManualvehicleOrderDetail[i].Qty = this.ManualvehicleOrderList[i].Qty;
                  this.ManualvehicleOrderDetail[i].OrderItemsId = this.ManualvehicleOrderList[i].OrderItemsId == undefined ? null : this.ManualvehicleOrderList[i].OrderItemsId;
                  this.ManualvehicleOrderDetail[i].VehicleOrdersProductID = this.ManualvehicleOrderList[i].VehicleOrdersProductID == undefined ? null : this.ManualvehicleOrderList[i].VehicleOrdersProductID;
                  this.ManualvehicleOrderDetail[i].RouteOrder = this.ManualvehicleOrderList[i].RouteOrder;
                }
    
                this.ManualvehiclePlanning.ManualvehicleOrderDetail = this.ManualvehicleOrderDetail;
                this.ManualvehiclePlanning.TransportServiceId = this.data.TransportService;
                this.ManualvehiclePlanning.TransporterId = this.data.Transporter;
                this.ManualvehiclePlanning.VehicleTypeID = this.data.VehicleType;
                this.ManualvehiclePlanning.VehicleNo = this.data.VehicleNo;
                this.ManualvehiclePlanning.DriverCode = this.data.Driver;
                this.ManualvehiclePlanning.DriverMobileNo = this.data.DriverMobileNo;
                this.ManualvehiclePlanning.VehiclePlacementDate = this.data.VehiclePlacementDate;
                this.ManualvehiclePlanning.EstimatedDeliveryDate = this.data.EstimatedDeliveryDate;
                this.ManualvehiclePlanning.BookingType = "primary"; //this.BookingType;
                this.ManualvehiclePlanning.BookingTypeAuto = null;
                this.ManualvehiclePlanning.LeadTime = this.data.LeadTime;
                this.ManualvehiclePlanning.Advance = this.data.Advance;
                // if (this.isSTPBooking) {
                //   this.ManualvehiclePlanning.BookingTypeAuto = this.STPModelListData[this.STPIdexId].BookingType;
                // }
                this.ManualvehiclePlanning.CompanyId = this.CompanyId;
                this.ManualvehiclePlanning.opa_userId = this.userId;
                this.ManualvehiclePlanning.Captain = null;
                this.ManualvehiclePlanning.IsFromRouteOptimization = false;
                this.ManualvehiclePlanning.RouteOptimization = true;
                this.ManualvehiclePlanning.PotterTripId = null;
                this.ManualvehiclePlanning.ChargeAmount = 0;
                this.ManualvehiclePlanning.IsFromManualPlanning = false;
                // this.ManualvehiclePlanning.IsBookingWithoutAssignedVehicle = false;
                console.log('===========', this.ManualvehiclePlanning)
                NewShipmentRequestPageComponent.that._appService.Post("ManualvehiclePlanning", "CreateBookingFromManualPlan", NewShipmentRequestPageComponent.that.ManualvehiclePlanning).subscribe((response) => {
                  // this.IsAssignvehicleSaveDisable = false;
                  if (response == true) {
                    this.UpdateBidIsBooking();
                    NewShipmentRequestPageComponent.that.toastr.success("Vehicle Assigned Successfully !", "Success");
                     this.hasSubmitted = true; 
                    Helpers.setLoading(false);
                  }
    
                  if (!this.hasSubmitted) {
                    this.IsAssignvehicleSaveDisable = false;
                    Helpers.setLoading(false);
                  }
                },
                  (err) => {
                    NewShipmentRequestPageComponent.that.toastr.error(err._body.replace(/"/g, ""), "Error");
                    this.IsAssignvehicleSaveDisable = false;
                    Helpers.setLoading(false);
                  }
                );
              }, 2000);
            });
            Helpers.setLoading(false);
          },
            (err) => {
              this.toastr.error(err._body.replace(/"/g, ""), "error");
              this.IsAssignvehicleSaveDisable = false;
              Helpers.setLoading(false);
            }
          );
        }
        Helpers.setLoading(false);
      }
    });

  }

  // added by priya - 28/01/25
  // updates bid detail isbooking=1
  UpdateBidIsBooking(){
    var obj: any = {}
    obj.BidDetailId = this.BidDetailId
    obj.OrderId = this.IndentId
    obj.TransporterId = this.TransporterId
    this._appService.Post("OrdersByVehicle", "UpdateTransporterBidIsBooking", obj).subscribe((response) => {
      console.log(response)
    },
    (err) => {
      console.log(err);
    });
  }

  GetBidDetails() {
    this._appService
      .GetByTwoId(
        "OrdersByVehicle",
        "GetBiddingDetails",
        this.IndentId,
        this.TransporterId
      )
      .subscribe(
        (res) => {
          this.BidDetailData = res;
          this.OrderListDetails = this.BidDetailData.Table[0];
          this.OrderNo = this.BidDetailData.Table[0].OrderNo;
          this.data.TransporterName = this.BidDetailData.Table[0].Transporter;
          this.VehicleDetails = this.BidDetailData.Table1;
          this.PackageListDetails = this.BidDetailData.Table2;
          this.AssignVehicleList = this.BidDetailData.Table4;
          console.log("OrderDetails", this.OrderListDetails);
          this.PackageDetails.data = this.PackageListDetails;
          const totals = this.PackageListDetails.reduce(
            (acc, item) => {
              acc.Qty += item.Qty || 0;
              acc.weight += item.weight || 0;
              acc.CBM += item.CBM || 0;
              acc.InvoiceAmount += item.InvoiceAmount || 0;
              return acc;
            },
            { Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 }
          );
          this.PackageDetails.footerData[0] = {
            ProductName: "Total",
            Qty: totals.Qty,
            weight: totals.weight,
            CBM: totals.CBM,
            InvoiceAmount: totals.InvoiceAmount,
          };
          if (Array.isArray(this.AssignVehicleList)  && this.AssignVehicleList.length > 0) {
              this.data.DriverMobileNo = this.AssignVehicleList[0].DriverMobileNo;
              this.data.Driver = this.AssignVehicleList[0].DriverCode;
              this.data.VehicleNo = this.AssignVehicleList[0].VehicleNo;
              let obj:any={};
              obj.value = this.data.Driver;
              obj.name = this.data.Driver;
              this.Driver.dropdownList=[];
              this.Driver.dropdownList.push(obj);

              let obj1:any={};
              obj1.value = this.data.VehicleNo;
              obj1.name = this.data.VehicleNo;
              this.VehicleNo.dropdownList=[];
              this.VehicleNo.dropdownList.push(obj1);
          }
          const Tb3 = this.BidDetailData.Table3;
          if(Tb3.length !==0){
            this.isBookingCreated = Tb3[0].IsBooking
          } else {
            this.isBookingCreated = this.BidDetailData.Table[0].IsBookingCreated;
          }
          // this.isBookingCreated = Tb3[0].IsBooking ? this.BidDetailData.Table[0].IsBookingCreated : false;
          console.log('AssignVehicleList',this.AssignVehicleList);
          console.log('isBookingCreated',this.isBookingCreated);
        },
        (error) => {
          console.error("GetBidDetails", error);
        }
      );
  }

  initiateCourierList(data: any) {
    this.courierListIds = data;
    var obj: any = {};
    obj.OrderId = this.courierListIds;

    this._appService.Post("OrdersByVehicle", "oc_GetCourierDataByIds", obj).subscribe(
      (response) => {
        this.CourierList = response.Table;
        this.CourierPackages = response.Table1;
        this.CourierDimentions = response.Table2;
        this.CourierAdditionalPack = response.Table4;
        this.OrdersPackage = response.Table5;

        var TransportName: any = [];
        this.CourierList.forEach((element) => {
          TransportName.push(element.TransportName);
        });
        this.TransportNames = Array.from(new Set(TransportName)).join(", ");

        this.OrderData.OrderCount = this.courierListIds.length;
        this.OrderData.SumOfQty = 0;
        this.OrderData.SumOfWeight = 0;
        this.OrderData.Volume = 0;
        this.OrderData.SumOFCFT = 0;

        this.CourierDimentions.forEach((element) => {
          this.OrderData.SumOfQty = this.OrderData.SumOfQty + element.Qty;
        });
        this.CourierPackages.forEach((element) => {
          this.OrderData.SumOFCFT = this.OrderData.SumOFCFT + element.CFT;
          this.OrderData.SumOfWeight =
            this.OrderData.SumOfWeight + element.weight;
          this.OrderData.Volume = this.OrderData.Volume + element.Volume;
        });
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Courier data !",
          "error"
        );
      });
  }

  async calculateRouteOptimization(OrderInfoData, DestinationLocation): Promise<Observable<any>> {
    try {
      if (DestinationLocation.length > 1) {
        const directionsService = new google.maps.DirectionsService();
        const waypts = [];
        for (let i = 0; i < DestinationLocation.length; i++) {
          waypts.push({
            location: DestinationLocation[i].location,
            stopover: true,
          });
        }
        await directionsService.route(
          {
            origin: OrderInfoData[0].origin,
            destination: OrderInfoData[0].destination,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
          },
          (response, status) => {
            if (status === "OK") {
              let ViewPoints = [];
              ViewPoints = response.routes[0].waypoint_order;
              var mainNum = 65;
              var subNum = 63;
              for (let i = 0; i < ViewPoints.length; i++) {
                DestinationLocation[ViewPoints[i]].Order = i;
                DestinationLocation[ViewPoints[i]].RouteOrder =
                  subNum == 63
                    ? String.fromCharCode(mainNum)
                    : String.fromCharCode(mainNum) +
                    String.fromCharCode(subNum);
                if (mainNum == 90 || subNum == 90) {
                  mainNum = subNum == 63 ? 65 : mainNum + 1;
                  subNum = 64;
                }
                subNum = subNum == 63 ? subNum : subNum + 1;
                mainNum = subNum == 63 ? mainNum + 1 : mainNum;
              }
              // this.OrderDestinationLocation1=(DestinationLocation);
              // return this.OrderDestinationLocation1;
            } else {
              // window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    } catch (error) {
      return DestinationLocation;
    }
    return DestinationLocation;
  }

  OnUpdateAssignVehicle(){
    // Added by priya - 01/04/2026 - cn(PRIYA-MAR26-015)
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      if (this.ULIPVerification === true) {
        if (this.ulipComp) {
          const weightMismatch = this.ulipComp.IsVahanWeightMismatchValidity && this.ulipComp.isWeightMismatch;
          if (this.ulipComp.hasAnyExpired() || weightMismatch) {
            this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
            return;
          }
        }
        // if (this.ulipComp && (this.ulipComp.hasAnyExpired() || this.ulipComp.isWeightMismatch)) {
        //   this.toastr.warning("Assignment failed: Invalid vehicle documents or driver's license");
        //   return;
        // }
        console.log('isUpdate')
      }
      let obj:any={};
      obj.Driver = this.data.Driver;
      obj.DriverMobileNo = this.data.DriverMobileNo;
      obj.VehicleNo = this.data.VehicleNo;
      obj.UserId = this.userId;
      obj.Id = this.AssignVehicleList[0].Id;
      console.log('OnUpdateAssignVehicle',obj);
      this._appService.Post('OrdersByVehicle','UpdateAssignedVehiclesList',obj).subscribe(
        (response)=>{
          this.toastr.success('Data updated successfully!');
        },
        (error)=>{
          this.toastr.error('Error while updating Assign Vehicle');
        }
      )
    }
  }

  //added by fahim 30-12-2025 :)
  ULIPVerification: boolean = false;
  LoadULIPVerification() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ULIPVerification").subscribe((response) => {
      if (response == '1') {
        this.ULIPVerification = true;
        this.DriverLicenseNo.isRequired=true;
        this.DriverDOB.isRequired=true;
      } else {
        this.ULIPVerification = false;
      }
      console.log('ULIPVerification>>',this.ULIPVerification);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }
  
  callTransportersType(){
    this.TransportersType = this.Transporter.dropdownList.filter((x) => x.id === this.data.Transporter)[0].TransporterType;
    if(this.TransportersType === 'Hired'){
      this.VehicleNo.addTag=true;
      this.Driver.addTag=true;
    }else{
      this.VehicleNo.addTag=false;
      this.Driver.addTag=false;
    }

    console.log('TransportersType inside callTransportersType',this.TransportersType);
  }
  //End - added by fahim 30-12-2025 :)

  // Added and commented by priya - 14/03/2026 - using common function for getting or saving vehicle and driver ulip - cn(PRIYA-MAR26-002)
  // ValidateBothVehDriver() {
  //   var vehicleNo = this.data.VehicleNo;
  //   var licenseNo = this.data.DriverLicenseNo;
  //   var dob = this.data.DriverDOB;
  //   this.Ulip.ValidateVehicleDriverUlip(licenseNo, dob, vehicleNo, this.userId).then(res => {
  //     if (this.ulipComp) {
  //       this.ulipComp.reloadData(licenseNo, vehicleNo);
  //     }
  //     this.IsVarifiedUlip = true;
  //   })
  //     .catch(err => {
  //       this.IsVarifiedUlip = false
  //     });
  // }

  // ValidateBothVehDriver(){
  //   if (!this.data.VehicleNo) {
  //     this.toastr.warning("Please enter vehicle No. to validate via Ulip!", "warning");
  //   }
  //   if (!this.data.DriverLicenseNo) {
  //       this.toastr.warning("Please enter driver license No.to validate via Ulip!", "warning");
  //   }
  //   if (!this.data.DriverDOB) {
  //     this.toastr.warning("Please enter driver Date Of Birth to validate via Ulip!", "warning");
  //   }

  //   this.vahanData = {};
  //   var vehicleNo = this.data.VehicleNo;
  //   if (vehicleNo != '' && vehicleNo != null) {
  //     this._appService.GetByOneParam("VehicleMaster", "GetVahanData",vehicleNo).subscribe(
  //     (response) => {
  //       this.vahanData = response.vahanData;
  //       if (this.vahanData && Object.keys(this.vahanData).length > 0) {
  //           const currentDate = new Date();
  //           const insuranceDate = this.parseDate(this.vahanData.RcInsuranceUpto);
  //           const fitDate = this.parseDate(this.vahanData.RcFitUpto);
  //           const taxDate = this.parseDate(this.vahanData.RcTaxUpto);

  //         if (
  //           !isNaN(insuranceDate.getTime()) &&
  //           !isNaN(fitDate.getTime()) &&
  //           !isNaN(taxDate.getTime()) &&
  //           insuranceDate > currentDate &&
  //           fitDate > currentDate &&
  //           taxDate > currentDate
  //         ) {
  //           this.isVehValid = true;
  //           this.ValidateDriverViaUlip();
  //           this.saveUlipData(vehicleNo, this.vahanData);
  //         }
  //         else {
  //           this.isVehValid = false;
  //           this.ValidateDriverViaUlip();
  //           this.toastr.warning("The vehicle's insurance, fitness, or tax is expired.");
  //         }
  //       }
  //       else {
  //         this.isVehValid = false;
  //         this.toastr.warning("No vehicle data found for the provided vehicle No.");
  //         this.ValidateDriverViaUlip();
  //       }
  //     },
  //     (err) => {
  //       this.ValidateDriverViaUlip();
  //       this.toastr.error("An error occured !", "error");
  //     });
  //   }
   
  // }

  ValidateDriverViaUlip() {
    this.sarathiData = {};
    var licenseNo = this.data.DriverLicenseNo;
    var dob = this.data.DriverDOB;
    if (dob) {
      const [day, monthStr, year] = dob.split('-');
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      
      const month = (months.indexOf(monthStr) + 1).toString().padStart(2, '0');
      const formatted = `${year}-${month}-${day.padStart(2, '0')}`;

      console.log(formatted); // 1987-05-26
      dob = formatted;
    }
    if (licenseNo != '' && dob != '' && licenseNo != null && dob != null) {
      this._appService.GetByTwoId("VehicleMaster","GetSarathiData",licenseNo,dob).subscribe(
        (response) => {
          this.sarathiData = response.sarathiData;
          if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
            //this.sarathiData.DlValidity = "2020-08-01T00:00:00"; //to comment
            var currentDATE1 = new Date();
            var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
            if (this.sarathiData.DlValidity > formattedDate1) {
              this.isDriverValid = true;
              this.validateULIP();
              this.saveUlipDataForDriver(licenseNo, dob, this.sarathiData);
            }
            else {
              this.isDriverValid = false;
              this.toastr.warning("Driver license is expired.");
            }
          }
          else {
            this.toastr.warning("No driver data found for the provided license number and date of birth.");
            this.isDriverValid = false;
          }
        },
        (err) => {
          this.toastr.error("An error occured !", "error");
        }
      );
    }
    
  }

  private parseDate(dateStr: string): Date {
    if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      return new Date(`${year}-${month}-${day}`);
    }
    return new Date(dateStr);
  }

  validateULIP(){
    if(this.isVehValid && this.isDriverValid){
      this.OnSaveAssignVehicle();
    }else{
      this.toastr.warning("No driver and vehicle data found .");
      return;
    }
  }
  
  saveUlipDataForDriver(licenseNo, dob, obj) {
    const PostData = {
      Type: 'Driver',
      ReferenceNo: licenseNo,
      ReferenceDate: dob,
      Response: JSON.stringify(obj),
      CreatedBy: this.userId,
    }
    this._appService.Post('VehicleMaster', 'saveUlipData', PostData).subscribe(
      (response) => {
        console.log('saveUlipData:', response);
      },
      (error) => {
        this.toastr.error('Error while saving ULIP data');
      }
    );
  }

  saveUlipData(vehicleNo, obj) {
    const PostData = {
      Type: 'Vehicle',
      ReferenceNo: vehicleNo,
      ReferenceDate: null,
      Response: JSON.stringify(obj),
      CreatedBy: this.userId,
    }
    this._appService.Post('VehicleMaster', 'saveUlipData', PostData).subscribe(
      (response) => {
        console.log('saveUlipData:', response);
      },
      (error) => {
        this.toastr.error('Error while saving ULIP data');
      }
    );
  }

}
